




























































































































































import {Component, Mixins} from "vue-property-decorator";
import MenuSet from "@/model/menuSet";
import Menu from "@/model/menu";
import SetMenuItem from "@/model/setMenuItem";
import Order from "@/model/order";
import store from "@/store";
import {namespace} from "vuex-class";
import qNotify from "@/common/qNotify";
import NumberGenerator from "@/common/mixins/numberGenerator";
import moment from "moment/moment";
import {DATETIME_FORMAT} from "@/common/constant";
import Option from "@/model/option";

const orderStore = namespace("OrderStore")
const menuStore = namespace("MenuStore")
const optionStore = namespace("OptionStore")
const menuSetStore = namespace("MenuSetStore")

@Component({
  name: "qDetailModal",
})
export default class qDetailModal extends Mixins(NumberGenerator) {
  @orderStore.Getter
  getOrderList!: Order[];
  @menuStore.Getter
  getMenuList!: Menu[];
  @optionStore.Getter
  getOptionList!: Option[];
  @menuSetStore.Getter
  getMenuSetList!: MenuSet[];

  public isShow = false;
  public isEdit = false;
  public isSubItem = false;
  public options: Option[] = [];
  public optionsInit: Option[] = [];
  public menuInit = new Menu();
  public menu = new Menu();
  public menuSetList: MenuSet[] = [];
  public menuSetListInit: MenuSet[] = [];
  public menuOptionList: SetMenuItem[] = [];

  public async show(menu, isEdit = false) {
    this.menu = JSON.parse(JSON.stringify(menu))
    this.menuSetList = [];
    this.options = []
    this.isEdit = isEdit

    this.getOptionList.map(value => {
      if (value.identifier.toString() === menu.identifier.toString()) {
        this.options.push(JSON.parse(JSON.stringify(value)))
      }
    })

    if (this.options.length > 0) this.isSubItem = true
    this.optionsInit = JSON.parse(JSON.stringify(this.options))

    if (!this.isEdit) {
      this.getMenuSetList.map(setMenu => {
        if (setMenu.identifier === menu.identifier) {
          this.menuSetList.push(JSON.parse(JSON.stringify(setMenu)))
        }
      })
    } else {
      this.menu = JSON.parse(JSON.stringify(menu.menuDetail))
      this.getOrderList.map(item => {
        if (item.identifier === menu.identifier) {
          this.menuSetList = JSON.parse(JSON.stringify(item.options))
        }
      })
      this.menuSetListInit = JSON.parse(JSON.stringify(this.menuSetList));
    }

    this.isShow = true

    this.menuInit = JSON.parse(JSON.stringify(this.menu))
  }

  public async cancel() {
    this.isShow = false;
    this.isSubItem = false
    this.menuOptionList = []
    this.options = []

    if (this.optionsInit.length > 0) {
      this.optionsInit.map(option => {
        store.dispatch('OptionStore/editOptionToList', option)
      })
    }
    store.dispatch('MenuStore/editMenuToList', this.menuInit)

    if (this.isEdit) {
      this.menuSetList = this.menuSetListInit
    }
  }

  public async removeToCart(menu) {
    this.isShow = false;
    this.isSubItem = false
    this.options = []
    let indexRemove = null
    this.getOrderList.map((value, key) => {
      if (value.identifier === menu.identifier) {
        indexRemove = key
      }
    })
    if (indexRemove !== null) {
      store.dispatch('OrderStore/removeOrderInList', indexRemove)
    }

    if (this.optionsInit.length > 0) {
      this.optionsInit.map(option => {
        option.quantity = 0
        store.dispatch('OptionStore/editOptionToList', option)
      })
    }
    this.menuInit.quantity = 0
    store.dispatch('MenuStore/editMenuToList', this.menuInit)
  }

  public async addToCart(order, menuSetList,  isEdit = false) {
    const oldQuantity = order.quantity
    let sumQuantity = 0;
    let parameters = {
      "act": "register",
      "mtd": "register",
      "name": order.name,
      "quantity": order.quantity,
      "orderTime": moment().format(DATETIME_FORMAT),
      "subIdentifier": "0",
      "price": order.price,
      "rowTotalPrice": 0,
      "isHaizen": "",
      "options": menuSetList,
      "identifier": order.identifier,
      "menuDetail": order,
    };

    if (this.options.length > 0) {
      this.options.map(option => {
        sumQuantity += option.quantity
      })
    }

    if ( isEdit ) {
      order.quantity = (this.options.length > 0) ? (oldQuantity - (oldQuantity - sumQuantity)) : order.quantity
    } else {
      order.quantity = (this.options.length > 0) ? sumQuantity : order.quantity
    }

    parameters = {
      ...parameters, ...{
        "quantity": order.quantity,
        "menuDetail": order,
      }
    }

    if (order.quantity === 0) {
      qNotify.error({
        text: 'The quantity must be greater than 0',
      });
    } else {
      if ( isEdit ) {
        store.dispatch('OrderStore/editOrderToList', new Order(parameters));
      } else {
        if (await this.validate(order)) {
          store.dispatch('MenuStore/editMenuToList', this.menuInit)
          this.setDefaultOptions()
          qNotify.error({
            text: 'The order is valid',
          });
        } else {
          store.dispatch('OrderStore/addOrderToList', new Order(parameters));
          store.dispatch('MenuStore/editMenuToList', order)
        }
      }
    }

    this.isShow = false;
    this.isSubItem = false
    this.options = []
  }

  private setDefaultOptions() {
    this.optionsInit.map(option => {
      store.dispatch('OptionStore/editOptionToList', option)
    })
  }

  private async validate(order) {
    let invalid = false;
    this.getOrderList.map(value => {
      if (value.identifier === order.identifier) {
        invalid = true;
      }
    })

    return invalid;
  }

  public addQuantityModal(item, isMenu = false) {
    item.quantity++
    this.updateModule(item, isMenu)
  }

  public subQuantityModal(item, isMenu = false) {
    item.quantity--
    this.updateModule(item, isMenu)
  }

  updateModule(item, isMenu) {
    if (isMenu) {
      store.dispatch('MenuStore/editMenuToList', new Menu({
        ...item, ...{
          quantity: item.quantity
        }
      }))
    } else {
      store.dispatch('OptionStore/editOptionToList', new Option({
        ...item, ...{
          quantity: item.quantity
        }
      }))
    }
  }

  public isDisableStatusModal(item) {
    return item.quantity === 0;
  }
}
